export const CHECKOUT_URL = "https://clincheck-en.impultienda.ar/checkout/";

export const images = {
  hero: "https://cdn.magicpatterns.com/uploads/wX577BvNDiCdvobwVG15ye/CLINCHECK-EN.png",
  author: "https://cdn.magicpatterns.com/uploads/kkm3adWSn2LaqsZCbhHwXj/DR._NATHAN_BROOKS_-_ORTHO.png",
};
